var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 30,
    height: 30,
    rx: 12,
    fill: "#1A1F37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5938H25.75V20.9063H17V19.5938ZM18.25 15.0001C18.0028 15.0001 17.7611 15.077 17.5555 15.2213C17.35 15.3655 17.1898 15.5705 17.0952 15.8103C17.0005 16.0501 16.9758 16.314 17.024 16.5686C17.0723 16.8232 17.1913 17.0571 17.3661 17.2406C17.5409 17.4242 17.7637 17.5492 18.0061 17.5998C18.2486 17.6505 18.4999 17.6245 18.7284 17.5252C18.9568 17.4258 19.152 17.2576 19.2893 17.0418C19.4267 16.8259 19.5 16.5722 19.5 16.3126C19.5017 16.1397 19.4705 15.9683 19.4083 15.8082C19.346 15.6482 19.254 15.5028 19.1376 15.3806C19.0212 15.2583 18.8827 15.1617 18.7303 15.0964C18.5779 15.0311 18.4146 14.9983 18.25 15.0001ZM24.5 15.0001C24.2528 15.0001 24.0111 15.077 23.8055 15.2213C23.6 15.3655 23.4398 15.5705 23.3452 15.8103C23.2505 16.0501 23.2258 16.314 23.274 16.5686C23.3223 16.8232 23.4413 17.0571 23.6161 17.2406C23.7909 17.4242 24.0137 17.5492 24.2561 17.5998C24.4986 17.6505 24.7499 17.6245 24.9784 17.5252C25.2068 17.4258 25.402 17.2576 25.5393 17.0418C25.6767 16.8259 25.75 16.5722 25.75 16.3126C25.7517 16.1397 25.7205 15.9683 25.6583 15.8082C25.596 15.6482 25.504 15.5028 25.3876 15.3806C25.2712 15.2583 25.1327 15.1617 24.9803 15.0964C24.8279 15.0311 24.6646 14.9983 24.5 15.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 11.9375H22.2587L23.5538 10.5778C23.6585 10.6078 23.7664 10.6237 23.875 10.625C24.1222 10.625 24.3639 10.548 24.5695 10.4038C24.775 10.2596 24.9352 10.0546 25.0298 9.81477C25.1245 9.57494 25.1492 9.31104 25.101 9.05644C25.0528 8.80184 24.9337 8.56798 24.7589 8.38442C24.5841 8.20087 24.3613 8.07586 24.1189 8.02522C23.8764 7.97458 23.6251 8.00057 23.3966 8.09991C23.1682 8.19925 22.973 8.36748 22.8357 8.58331C22.6983 8.79915 22.625 9.05291 22.625 9.3125C22.6263 9.42649 22.6414 9.53984 22.67 9.64981L20.4913 11.9375H13.25C12.9186 11.9378 12.6008 12.0762 12.3665 12.3223C12.1321 12.5684 12.0003 12.902 12 13.25V23.75C12.0003 24.098 12.1321 24.4316 12.3665 24.6777C12.6008 24.9238 12.9186 25.0622 13.25 25.0625H28.25C28.5814 25.0622 28.8992 24.9238 29.1335 24.6777C29.3679 24.4316 29.4997 24.098 29.5 23.75V13.25C29.4997 12.902 29.3679 12.5684 29.1335 12.3223C28.8992 12.0762 28.5814 11.9378 28.25 11.9375V11.9375ZM13.25 23.75V13.25H28.25V23.75H13.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_17",
    x: 0.5,
    y: -2.38419e-7,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_17",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robotIcon.f7b954d6410273596ee86c9c63cdf131.svg";
export { ForwardRef as ReactComponent };